/** Equity/index option contract size (shares per contract, dollars per point).
 *  Hardcoded until we read Schwab `multiplier` / tastytrade `notional-multiplier`. */
export const OPTION_MULTIPLIER = 100;
